<script setup lang="ts">
import { ref, computed } from 'vue';
import Select from 'primevue/select';

interface Props {
  seasonObject: object;
  listMonth: Array<any>;
  dateType: string;
}
const props = defineProps<Props>();

const emits = defineEmits<{ 'update:seasonObject': [value: any] }>();

const listDay = ref([]);

const seasonal = computed({
  get() {
    return props.seasonObject;
  },
  set(value) {
    emits('update:seasonObject', value);
  }
});

const getDaysDefault = (month = 1) => {
  const year = new Date().getFullYear();
  const lastDayOfMonth = new Date(year, month, 0).getDate();
  const daysArray = [];

  for (let i = 1; i <= lastDayOfMonth; i++) {
    daysArray.push(i.toString());
  }
  listDay.value = daysArray;
  return daysArray;
};
</script>

<template>
  <div class="seasonal-dropdown">
    <div class="grid seasonal-dropdown">
      <div class="col-12 md:col-6 flex flex-column pl-0">
        <label for="get-month">{{ dateType === 'start' ? $t('management.package.start_motnh') : $t('management.package.end_motnh') }}</label>
        <Select id="start-month" v-if="dateType === 'start'" v-model="seasonal.startMonth" inputId="get-month" :options="listMonth" optionLabel="name" optionValue="key" class="p-column-filter"></Select>
        <Select id="end-month" v-else v-model="seasonal.endMonth" inputId="get-month" :options="listMonth" optionLabel="name" optionValue="key" class="p-column-filter"></Select>
      </div>
      <div class="col-12 md:col-6 flex flex-column">
        <label for="get-date">{{ dateType === 'start' ? $t('management.package.start_day') : $t('management.package.end_day') }}</label>
        <Select id="start-day" v-if="dateType === 'start'" v-model="seasonal.startDay" inputId="get-date" :options="getDaysDefault(seasonal.startMonth)" class="p-column-filter"></Select>
        <Select id="end-day" v-else v-model="seasonal.endDay" inputId="get-date" :options="getDaysDefault(seasonal.endMonth)" class="p-column-filter"></Select>
      </div>
    </div>
  </div>
</template>
